/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 18:12:00
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * 报警类型
  */
 let EnumAlaemType  = {
     "移动侦测告警"             : new EnumItem('移动侦测告警', "10002"),
     "人体感应告警"              : new EnumItem('人体感应告警', "10010"),
     "遮挡告警"               : new EnumItem('遮挡告警', "10011"),
     "视频丢失"               : new EnumItem('视频丢失', "10012"),
     "越界侦测"               : new EnumItem('越界侦测', "10013"),
     "区域入侵"               : new EnumItem('区域入侵', "10014"),
     "人脸检测事件"               : new EnumItem('人脸检测事件', "10015"),
     "物品遗留侦测"               : new EnumItem('物品遗留侦测', "10023"),
     "物品拿取侦测"               : new EnumItem('物品拿取侦测', "10024"),
     "非法停车侦测"               : new EnumItem('非法停车侦测', "10025"),
     "人员聚集侦测"               : new EnumItem('人员聚集侦测', "10026"),
     "徘徊检测侦测"               : new EnumItem('徘徊检测侦测', "10027"),
     "快速移动侦测"               : new EnumItem('快速移动侦测', "10028"),
     "进入区域侦测"               : new EnumItem('进入区域侦测', "10029"),
     "离开区域侦测"               : new EnumItem('离开区域侦测', "10030"),
     "移动侦测告警开始"               : new EnumItem('移动侦测告警开始', "12000"),
     "视频信号丢失"               : new EnumItem('视频信号丢失', "12001"),
     "遮挡告警开始"               : new EnumItem('遮挡告警开始', "12002"),
     "移动侦测告警结束"               : new EnumItem('移动侦测告警结束', "12086"),
     "遮挡告警结束"               : new EnumItem('遮挡告警结束', "12087"),
     ...enumMixn
}
 export default EnumAlaemType